export default "__VITE_ASSET__CrfMBlRP__"